import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardService } from 'src/app/Services/dashboard.service';
import { GalleryItems } from 'src/app/Services/galleries.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ConnectedArtistResponse, GalleryDashboard, NewProduct } from 'src/app/models/response/galleryDashboard.models';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { OnBoardingService } from 'src/app/Services/shared/onboarding.service';

@Component({
    selector: 'app-gallery-dashboard',
    templateUrl: './gallery-dashboard.component.html',
    providers: [DashboardService],
    standalone: false
})
export class GalleryDashboardComponent implements OnInit {
  public galleries: GalleryItems[] = [];
  @ViewChild('op', { static: false }) op!: OverlayPanel;
  public visible: boolean = false;
  public hoveredProduct: any | null = null;
  public isProductDetailDialogVisible: boolean = false;
  public selectedProduct: NewProduct | null = null;
  public venueLabel: string[] = [];
  public gallerySaleRevenueData: any;
  public GallerySoldProductData: any;
  public options: any;
  public authConfig: AuthConfig = {};
  public connectedArtits!: ConnectedArtistResponse;
  public gallerySalesDataLoaded: boolean = false;

  public selectedTabIndex: number = 0;
  public galleryDashboardData: GalleryDashboard = {
    ConnectedArtist: [],
    GalleryStockReports: [],
    ConsignmentApprovalPending: [],
    ProductRequestPending: [],
    IncomingGalleryConnectionRequest: []
  };
  public isAuthenticated!: boolean;
  public isGallery: boolean = false;
  public showDashboard: boolean = true;

  constructor(private router: Router,
    private dashboardService: DashboardService,
    private ngxSpinnerService: NgxSpinnerService,
    private authService: AuthService,
    private onBoardingService: OnBoardingService) {
  }

  public ngOnInit(): void {
    this.getGalleryDashboard();
    this.authConfig = this.authService.getAuthConfig();
    this.isAuthenticated = this.authService.isAuthenticated();
    if (this.isAuthenticated) {
      this.authConfig = this.authService.getAuthConfig();
      this.isGallery = this.authConfig.IsGallery || false;
      var currentUser = this.authService.getCurrentUser();

      this.onBoardingService.getUpdatedLocalStorageValue.subscribe((tourVisible: boolean) => {
        this.showDashboard = !tourVisible;
        // console.log('TourVisible: ' + tourVisible);
      });
    }

  }

  public getGalleryDashboard() {
    this.ngxSpinnerService.show();
    this.dashboardService.getGalleryDashboard().subscribe((data: GalleryDashboard) => {
      console.log(data);
      this.ngxSpinnerService.hide();
      data.BestPerformingArtistData?.forEach((item) => {
        //set the color class based on the percentage
        var colorClass = this.getColorBasedOnPercentage(item.PercentageOfTotal);
        item.ColorClassBasedOnPercentage = 'bg-' + colorClass;
        item.TextBasedOnPercentage = `<span class="text-${colorClass}">${item.PercentageOfTotal}%</span>`;
      });

      data.BestPerformingArtTypeData?.forEach((item) => {
        //set the color class based on the percentage
        var colorClass = this.getColorBasedOnPercentage(item.PercentageOfTotal);
        item.ColorClassBasedOnPercentage = 'bg-' + colorClass;
        item.TextBasedOnPercentage = `<span class="text-${colorClass}">${item.PercentageOfTotal}%</span>`;
      });

      this.galleryDashboardData = data;
      this.gallerySalesDataLoaded = true;
    },
      (error) => {
        console.error(error);
      });
  }

  // TypeScript Code
  public getColorBasedOnPercentage(percentage: number): string {
    if (percentage >= 80) {
      return 'success';
    } else if (percentage >= 60) {
      return 'warning';
    } else if (percentage >= 50) {
      return 'info';
    } else {
      return 'danger';
    }
  }

  public getProgressBarWidth(percentageOrDays: number): string {
    const minWidth = 10; // Set your minimum width here
    const calculatedWidth = Math.max(percentageOrDays, minWidth);
    return calculatedWidth + '%';
  }

  public getProgressBarColorClass(percentageOrDays: number): string {
    const color = this.getColorBasedOnPercentage(percentageOrDays);
    return 'bg-' + color;
  }

  public navigateToProduct(product: NewProduct) {
    //:artistId/artworks/:artworkId
    this.router.navigate(['/', product.ArtistId, 'artworks', product.ArtistProductId]);
  }

  public showOverlayPanel(event: MouseEvent, product: any): void {
    setTimeout(() => {
      //to set product into hover details product
      this.hoveredProduct = product;
      // toggle for hide and show panal
      this.op.toggle(event);
    }, 200);
  }



  public onSalesDurationChange(event: any) {

  }

  public showProductDialog(product: NewProduct): void {
    this.selectedProduct = product;
    this.isProductDetailDialogVisible = true;
  }
  public naviGateToViewPage(product: NewProduct) {
    //:artistId/artworks/:artworkId
    this.router.navigate(['/', product.ArtistId, 'artworks', product.ArtistProductId]);
  }

  public hideDialog(): void {
    this.isProductDetailDialogVisible = false;
    this.selectedProduct = null;
  }
  isToday(date: Date): boolean {
    const today = new Date();
    return date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate();
  }

  // Function to calculate days ago from a number
  dispatchedDaysAgo(daysAgo: number): Date {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - daysAgo);
    return currentDate;
  }

  public onTabChange(event: any) {
    if (event.index) {
      this.selectedTabIndex = event.index;
    } else {
      console.log('Event is undefined or index is not present');
    }
  }

}